import React from "react";
import {
  Box,
  Text,
  IconButton,
  Spacer,
  useColorMode,
  Button,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import Translate from "../../components/LanguageTranslation/Translate";

const RightHeader = ({ onOpenCategoryModal, selectedTrip }) => {
  const { colorMode } = useColorMode();

  return (
    <Box
      flex="1"
      display="flex"
      flexDirection="column"
      pb={{base: 2, md : 0}}
      maxH="8vh"
      borderBottom="1px"
      borderColor="blackAlpha.200"
      overflowY="hidden"
    >
      <Box
        display="flex"
        alignItems="center"
        bg={colorMode === "dark" ? "gray.700" : "white"}
        width="100%"
        height="100%"
        p={4}
        pt={0}
        pb={0}
        boxSizing="border-box"
        overflowY="hidden"
      >
        <Text
          fontSize="md"
          fontWeight="bold"
          mb={0}
          // mt={2}
          color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
        >
          <Translate text="All categories" />
        </Text>
        <Spacer />
        <Button
          // display={{ base: "block", md: "none" }}
          ml={2}
          bg="#286328"
          size="sm"
          color="white"
          _hover="none"
          borderRadius="full"
          leftIcon={<AddIcon />}
          onClick={onOpenCategoryModal}
          isDisabled={!selectedTrip} // Disable button if no trip is selected
        >
          <Translate text="Add Category" />
        </Button>
      </Box>
    </Box>
  );
};

export default RightHeader;
